import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CanActivateAppGuard } from './can-activate-app/can-activate-app.guard';
import { CanActivatePurchaseAndSummaryGuard } from './feature/checkout/purchase-and-summary/can-activate-purchase-and-summary/can-activate-purchase-and-summary.guard';
import { CanActivateGiftCardBalanceGuard } from './feature/gift-card-balance/can-activate-gift-card-balance/can-activate-gift-card-balance.guard';
import { CheckoutModule } from './feature/checkout/checkout.module';
import { GiftCardPurchaseModule } from './feature/gift-card-purchase/gift-card-purchase.module';
import { GiftCardBalanceModule } from './feature/gift-card-balance/gift-card-balance.module';

const routes: Routes = [
    { path: '', redirectTo: '/gift', pathMatch: 'full' },
    {
        path: '',
        canActivate: [CanActivateAppGuard],
        children: [
            {
                path: 'checkout',
                loadChildren: () => CheckoutModule,
                canActivate: [CanActivatePurchaseAndSummaryGuard],
            },
            {
                path: 'gift',
                loadChildren: () => GiftCardPurchaseModule,
            },
            {
                path: 'gift/balance',
                loadChildren: () => GiftCardBalanceModule,
                canActivate: [CanActivateGiftCardBalanceGuard],
            },
        ],
    },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
    ],
    providers: [CanActivateAppGuard],
    exports: [RouterModule],
})
export class AppRoutingModule {}
